module.exports = __webpack_public_path__ + "img/note-icon.0631a105.svg";